module.exports = __webpack_public_path__ + "static/farmers_accountdetails-3f15cb2ead6350d2affbf26b733b3b93.png";